const concatLists = (sourceList, list) => {
  sourceList.append(...list.children);
  list.remove();

  return sourceList;
};

export default concatLists;
